import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'report-icon',
    templateUrl: './report-icon.component.html',
    styleUrls: ['./report-icon.component.scss'],
    standalone: false,
})
export class ReportIconComponent implements OnInit {
    @Input() fileName: string;

    @Output() onTrigger = new EventEmitter();

    fileType: string;

    constructor() {}

    ngOnInit() {
        const formatIndexStart = this.fileName?.indexOf('.');
        const format = this.fileName?.substring(formatIndexStart + 1);
        if (formatIndexStart === -1) {
            this.fileType = 'file';
            return;
        }
        switch (format) {
            case 'xls':
            case 'xlsx':
                this.fileType = 'xls';
                break;
            case 'csv':
            case 'fvu':
            case 'txt':
                this.fileType = 'csv';
                break;
            case 'doc':
            case 'docx':
                this.fileType = 'doc';
                break;
            case 'pdf':
                this.fileType = 'pdf';
                break;
            case 'png':
            case 'jpg':
            case 'jpeg':
                this.fileType = 'image';
                break;
            case 'ppt':
            case 'pptx':
                this.fileType = 'ppt';
                break;
            case 'json':
                this.fileType = 'json';
                break;
            case 'xml':
            case 'zip':
                this.fileType = 'xml';
                break;
            case 'html':
                this.fileType = 'html';
                break;
            default:
                format && console.error('No format defined for: ' + format);
                this.fileType = 'file';
                break;
        }
    }
}
